module.exports = __webpack_public_path__ + "static/img/declaration-pdf.83f4f6bb.svg";